import React, { useEffect, useState } from 'react'
import { Table, Checkbox, Button, message, Radio } from 'antd'
import { useLocation } from 'wouter'

export default function ContentGenerated() {
  const [data, setData] = useState([])
  const [columnsTable, setColumnsTable] = useState([])
  const [checkedList, setCheckedList] = useState(null)
  const [options, setOptions] = useState([])
  const [loading, setLoading] = useState(false)
  const [newCampaign, setNewCampaign] = useState(false)
  const [location, setLocation] = useLocation()
  const [contentData, setContentData] = useState({})
  const [forceImport, setForceImport] = useState(false)

  useEffect(() => {
    init()
  }, [])
  async function init() {
    const res = await fetch(
      `/db/guillotina/@get-content-generated`
    ).then((res) => res.json())

    const columns = Object.keys(res[0])
    const reorderedColumns = [
      'feed_generated',
      ...columns.filter((col) => col !== 'feed_generated'),
    ]

    setColumnsTable([
      ...reorderedColumns.map((column) => ({
        title: column.replace(/_/g, ' ').toUpperCase(),
        dataIndex: column,
        columnKey: column,
        width: 100,
        render:
          column === 'promoted_products'
            ? (text) => text.join(' ')
            : column === 'feed_generated'
            ? (value, record) => (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '8px',
                  }}
                >
                  <Button
                    type="primary"
                    size="small"
                    loading={loading}
                    onClick={() => generateFeed(record.id)}
                  >
                    Generar Feed
                  </Button>
                </div>
              )
            : column === 'id'
            ? (text, record) => (
                <Button
                  type="link"
                  onClick={() => handleEdit(record)}
                  style={{ padding: 0 }}
                >
                  {text}
                </Button>
              )
            : undefined,
      })),
    ])

    const options = reorderedColumns.map((key) => ({
      label: key,
      value: key,
    }))

    setOptions(options)
    setData(res)
    setCheckedList(reorderedColumns)

    const contentMap = {}
    res.forEach((item) => {
      contentMap[item.id] = item
    })
    setContentData(contentMap)
  }

  async function columnsHidden(value) {
    setCheckedList(value)
    setColumnsTable(
      value.map((column) => ({
        title: column.replace(/_/g, ' ').toUpperCase(),
        dataIndex: column,
        columnKey: column,
        width: 100,
      }))
    )
  }

  function createNewContent() {
    setLoading(true)
    setNewCampaign(true)
    setLocation('/content_ai/add_new_content')
    setLoading(false)
  }

  async function generateFeed(id) {
    try {
      setLoading(true)
      const response = await fetch('/db/guillotina/@generate-feed-ai', {
        method: 'POST',
        body: JSON.stringify({
          ids: [id],
        }),
      })

      if (!response.ok) {
        throw new Error('Error al generar el feed')
      }

      message.success('Feed generado correctamente')
      // Actualizamos los datos de la tabla
      init()
    } catch (error) {
      message.error('Error al generar el feed: ' + error.message)
    } finally {
      setLoading(false)
    }
  }

  function handleEdit(record) {
    setLocation(`/content_ai/edit_content/${record.id}`)
    sessionStorage.setItem('editContent', JSON.stringify(record))
  }

  async function importFeed() {
    try {
      setLoading(true)
      const response = await fetch('/db/guillotina/@generate-content-from-ai', {
        method: 'GET',
        headers: {
          Authorization: 'Basic cm9vdDp2aW5pMjAxNg==',
          ...(forceImport ? { force: 'true' } : {}),
        },
      })

      message.success('Feed importado correctamente')
      init()
    } catch (error) {
      console.log(error)
      message.error('Error al importar el feed: ' + error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div
      className="container"
      style={{ backgroundColor: '#fff', padding: '30px' }}
    >
      <div style={{ 'margin-top': '10px' }}>
        <div className="field">
          <label className="label">Agregar nueva campaña</label>
        </div>
        <div style={{ display: 'flex', gap: '10px' }}>
          <Button type="primary" loading={loading} onClick={createNewContent}>
            Add new
          </Button>
        </div>
        <div className="field">
          <label className="label">Importar feed IA</label>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <Button type="default" loading={loading} onClick={importFeed}>
              Importar Feed
            </Button>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <span>Forzar importación:</span>
            <Radio.Group
              value={forceImport}
              onChange={(e) => setForceImport(e.target.value)}
            >
              <Radio value={false}>No</Radio>
              <Radio value={true}>Sí</Radio>
            </Radio.Group>
          </div>
        </div>
      </div>
      <div style={{ 'margin-top': '10px' }}>
        <div className="field">
          <label className="label">
            TABLA INFORMATIVA CON LOS DATOS DE ai_campaign_generation
          </label>
          <div style={{ 'margin-top': '10px' }}>
            {checkedList ? (
              <Checkbox.Group
                value={checkedList}
                options={options}
                onChange={(value) => {
                  columnsHidden(value)
                }}
              />
            ) : null}
            <Table
              columns={columnsTable}
              dataSource={data}
              bordered
              sticky
              scroll={{
                x: true,
                y: true,
              }}
              size="large"
              pagination={false}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
